// src/hooks/useKeycloakInit.ts
import { useEffect, useState } from "react";
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { useDispatch } from "react-redux";
import { authenticateToken } from "../../actions/app.action";

const { pathname } = window.location;

const segments = pathname?.split("/")?.filter(Boolean);
const clientName = segments?.length > 0 ? segments[0] : null;
const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOCK_REALM,
  url: process.env.REACT_APP_KEYCLOCK_URL,
  clientId: clientName ? clientName : process.env.REACT_APP_KEYCLOCK_CLIENT_ID,
};

const useKeycloakInit = () => {


  const [keycloak, setKeycloak] = useState<Keycloak.KeycloakInstance | null>(null);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const kc = new (Keycloak as any)(keycloakConfig);

    kc.init({ 
      onLoad: "login-required",
      checkLoginIframe: false,
      pkceMethod: 'S256'
    }).then((auth: any) => {
      if (!auth) {
        localStorage.clear();
      } else {
        setKeycloak(kc);
        setAuthenticated(true);

        localStorage.setItem("authentication", kc.token || "");
        localStorage.setItem("refreshToken", kc.refreshToken || "");
      }
    }).catch(() => {
      localStorage.clear();
    });
  }, []);


  return { keycloak, authenticated };
};

export default useKeycloakInit;
